"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberContextSchema = exports.TierContextSchema = exports.UserContextSchema = exports.CampaignContextSchema = exports.TeamContextSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const accounts_1 = require("./accounts");
const auth_1 = require("./auth");
const status_1 = require("./status");
const system_1 = require("./system");
exports.TeamContextSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    name: core_1.NameSchema,
    status: status_1.TeamStatusSchema,
    currency: core_1.CurrencySchema,
    isAgencyAccount: typebox_1.Type.Boolean(),
    clientType: system_1.ClientTypeSchema,
});
exports.CampaignContextSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    name: core_1.NameSchema,
    status: status_1.CampaignStatusSchema,
    channelType: system_1.ChannelTypeSchema,
});
exports.UserContextSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    name: core_1.NameSchema,
    role: auth_1.UserRoleSchema,
    status: status_1.UserStatusSchema,
});
exports.TierContextSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    name: core_1.NameSchema,
    hosted: typebox_1.Type.Boolean(),
    payment: accounts_1.PaymentModelSchema,
    status: status_1.TierStatusSchema,
});
exports.MemberContextSchema = (0, core_1.StrictObject)({
    role: auth_1.TeamRoleSchema,
    assigned: typebox_1.Type.Optional(auth_1.TeamRoleSchema),
});
